import { type WorkerRequirementsIncludedDocumentsType } from "@clipboard-health/contract-worker-app-bff";
import constate from "constate";
import { useState } from "react";

import { type WorkerRequirement } from "../api/types";

/**
 * This context is intentionally powered from outside (Container component) rather than fetching data internally.
 * This design decision allows:
 * 1. The Container to handle all data fetching, loading states, and error handling
 * 2. Child components to safely assume the requirement is always defined
 * 3. Separation of concerns - Container manages data fetching, components focus on rendering
 * 4. Easier testing as components don't need to mock API calls
 */
interface DocumentDetailsContextValue {
  requirement: WorkerRequirement;
}

function useRequirementDetails(props: DocumentDetailsContextValue) {
  const [uploadedDocument, setUploadedDocument] =
    useState<WorkerRequirementsIncludedDocumentsType>();

  const { requirement } = props;

  return {
    requirement,
    uploadedDocument,
    setUploadedDocument,
  };
}

export const [RequirementDetailsProvider, useRequirementDetailsContext] =
  constate(useRequirementDetails);
